import { combineEpics } from "redux-observable";
import { of } from "rxjs";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import "../ducks/index.js";
import { ApiErrorType, getAsyncRequestStatus } from "@ane/core/lib/models";
import DataSourceResource from "../../../DataSource.resource.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { WorkspaceMigrationStatusCodes } from "@ane/core/lib/models/IAsyncWrapper/WorkspaceMigrationModels";
import { MigrationErrorMessages } from "@ane/core/lib/constants/WorkspaceMigration.constants";
import { dataSourceDetailActionTypes, dataSourceDetailLoadingAction, dataSourceDetailLoadedAction } from "../ducks/DataSourceDetail.ducks.js";
const loadDataSourceArgs = {
  filterOnType: dataSourceDetailActionTypes.LOAD,
  skiploadDataTransform: true,
  loadResource: (payload, state) => {
    return DataSourceResource.getDataSource(payload.workspaceId, payload.dataSourceName);
  },
  loadingAction: dataSourceDetailLoadingAction,
  loadedAction: (successData, payload, error) => {
    let errorContext = void 0;
    if (EnvironmentService.wsplitEnableRedirects() && successData.statusCode === WorkspaceMigrationStatusCodes.MovedPermanently) {
      errorContext = {
        statusCode: successData.statusCode,
        displayError: MigrationErrorMessages.MovedPerminenty,
        type: ApiErrorType.MovedPermanently,
        correlationId: "No correlationId provided"
      };
    }
    const result = {
      status: getAsyncRequestStatus(error || ""),
      data: successData.getSuccessData(),
      error,
      errorContext
    };
    return of(dataSourceDetailLoadedAction(payload, result));
  }
};
const loadDataSourceEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadDataSourceArgs);
const dataSourceDetailEpic = combineEpics(loadDataSourceEpic);
export {
  dataSourceDetailEpic as default,
  loadDataSourceEpic
};
//# sourceMappingURL=DataSourceDetailEpic.js.map
